import { render } from "./DropzoneArea.vue?vue&type=template&id=5709f43a&scoped=true"
import script from "./DropzoneArea.vue?vue&type=script&lang=js"
export * from "./DropzoneArea.vue?vue&type=script&lang=js"

import "./DropzoneArea.vue?vue&type=style&index=0&id=5709f43a&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5709f43a"]])

export default __exports__